export default "__VITE_ASSET__gg0YgLst__"